import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

let cache = null;

// Published portfolio count; the nav/footer only show "Portfolio" when > 0.
export const usePortfolioCount = () => {
  const [count, setCount] = useState(cache ?? 0);
  useEffect(() => {
    if (cache !== null || !API) return;
    axios.get(`${API}/portfolio/meta`).then((r) => { cache = r.data?.count || 0; setCount(cache); }).catch(() => { cache = 0; });
  }, []);
  return count;
};
